import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PushNotificationsComponent} from './push-notifications.component';
import {AuthGuard} from "@app/auth/auth.guard";
import {RouterModule} from "@angular/router";
import {MaterialModule} from "@app/material/material.module";
import {ReactiveFormsModule} from "@angular/forms";
import {FuseSharedModule} from "@fuse/shared.module";
import {FlexLayoutModule} from "@angular/flex-layout";
import {DropdownMenuComponent} from './dropdown-menu/dropdown-menu.component';
import {MenuItemComponent} from './dropdown-menu/menu-item/menu-item.component';
import {PushNotificationsService} from "@app/main/content/push-notifications/push-notifications.service";

const routes = [
  {
    path: "send-message",
    component: PushNotificationsComponent,
    canActivate: [AuthGuard],
    resolve: {
      data: PushNotificationsService
    }
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FlexLayoutModule,
    MaterialModule,
    FuseSharedModule,
  ],
  declarations: [PushNotificationsComponent, DropdownMenuComponent, MenuItemComponent]
})
export class PushNotificationsModule {
}
